import type { PlacementBillingType } from './Placement';

export interface RawCreateForecastRequest {
  bid_cents: number;
  billing_type: PlacementBillingType;
  budget_daily_cents?: number | null;
  keywords?: string[];
  metrics: ForecastMetricType[];
  placement_id: string;
  target_category_keys?: string[];
}

export enum ForecastMetricType {
  IMPRESSIONS = 'impressions',
  CLICKS = 'clicks',
}

export interface RawForecastResponse {
  placement_id: string;
  metrics: ForecastResponseMetrics;
}

export interface ForecastResponseMetrics {
  impressions?: number;
  clicks?: number;
}

export interface RawBidSuggestionsRequest {
  placement_id: string;
  billing_type: BidSuggestionsRequestBillingType;
  target_category_keys?: string[];
  keywords?: string[];
}

export enum BidSuggestionsRequestBillingType {
  CPM = 'CPM',
  CLICK = 'CLICK',
  ADD_TO_CART = 'ADD_TO_CART',
}

export interface RawBidSuggestionsResponse {
  placement_id: string;
  min_bid_cents: number;
  max_bid_cents: number;
}

// Inventory Forecast Types
export interface RawInventoryForecastRequest {
  placement_id: string;
  start_date: string;
  end_date?: string | null;
  target_category_keys?: string[];
  keywords?: string[];
  advertised_skus_count?: number | null;
}

export interface PositionInventory {
  position: number;
  total_impressions: number | null;
  reserved_impressions: number | null;
  auction_reserved_impressions: number | null;
  available_impressions: number | null;
}

export interface RawInventoryForecastResponse {
  placement_id: string;
  start_date: string;
  end_date: string;
  /** @deprecated Use positions array instead */
  total_impressions?: number | null;
  /** @deprecated Use positions array instead */
  reserved_impressions?: number | null;
  /** @deprecated Use positions array instead */
  available_impressions?: number | null;
  positions: PositionInventory[];
  daily_availability_inventory: DailyInventory[];
  /** Measured inventory of the last 14 complete days (UTC), the history the forecast averages */
  delivery?: InventoryDelivery;
}

export interface DailyInventory {
  date: string;
  /** @deprecated Use positions array instead */
  total_impressions?: number | null;
  /** @deprecated Use positions array instead */
  reserved_impressions?: number | null;
  /** @deprecated Use positions array instead */
  available_impressions?: number | null;
  positions: PositionInventory[];
}

export interface DeliveryPosition {
  position: number;
  ad_request_with_ads: number | null;
  /** Impressions the position could have delivered, on the forecast's scale */
  total_impressions: number | null;
  /** Unfilled impressions are total_impressions - delivered_impressions */
  delivered_impressions: number | null;
}

export interface DailyDelivery {
  date: string;
  ad_request: number | null;
  ad_request_with_ads: number | null;
  positions: DeliveryPosition[];
}

export interface InventoryDelivery {
  start_date: string;
  end_date: string;
  ad_request: number | null;
  ad_request_with_ads: number | null;
  /** ad_request_with_ads / ad_request in hundredths of a percent: 7525 is 75.25% */
  fill_rate: number | null;
  positions: DeliveryPosition[];
  /** Days without ad requests are omitted */
  daily: DailyDelivery[];
}
